import moment from 'moment';
require('moment-timezone');

export const formatDate = (d) => {
    if(d && moment(d, "YYYY-MM-DDThh:mm:ss.SSSZ").isValid()){        
        const dateTime = moment(d)//.tz('US/Eastern');
        return dateTime.format("MM/DD/YYYY")
    }
    return undefined
}